// src/context/LeaderViewContext.tsx
import React, { createContext, useState, useContext, ReactNode } from 'react';

export type LeaderViewType = 'home' | 'members' | 'post' | 'event' | 'managePosts' | 'leadershipVideos' | 'tier4Positions';

interface LeaderViewContextType {
  activeView: LeaderViewType;
  setActiveView: (view: LeaderViewType) => void;
}

const defaultContext: LeaderViewContextType = {
  activeView: 'home',
  setActiveView: () => {},
};

export const LeaderViewContext = createContext<LeaderViewContextType>(defaultContext);

export const LeaderViewProvider: React.FC<{ children: ReactNode }> = ({ children }) => {
  const [activeView, setActiveView] = useState<LeaderViewType>('home');

  return (
    <LeaderViewContext.Provider value={{ activeView, setActiveView }}>
      {children}
    </LeaderViewContext.Provider>
  );
};

export const useLeaderView = () => useContext(LeaderViewContext);
